'use strict';

const dates = require('util/date');
const $ = require('jquery');
const cookies = require('js-cookie');

require('magnific-popup');

const filter = require('lodash/filter');
const find = require('lodash/find');
const uniqBy = require('lodash/uniqBy');
const orderBy = require('lodash/orderBy');
const isEqual = require('lodash/isEqual');
const map = require('lodash/map');
const isEmpty = require('lodash/isEmpty');

const FuseJS = require('fuse.js');

const cookieSettings = {
    expires: 30, // number of days cookie will be valid for
    path: '/',
    domain: '.' + window.location.hostname.split('.').slice(1).join('.'),
};

function controller($scope, $timeout, $attrs, $window, $location, plannerService) {
    let vm = this;

    let allResults = [];
    let allFilters = null;
    let fuse = null;

    let maxTicketPrice = 0;

    vm.totalCount = 0;
    vm.results = [];
    vm.filters = null;
    vm.ticketCount = 2;
    vm.date_filter = {
        start: null,
        end: null,
    };
    vm.showClearDates = false;

    vm.showOptions = undefined;
    vm.selectedShow = 'Any Show';
    vm.selectedMonth = 'any';
    vm.selectedPriceRange = {
        min: 0,
        max: 150
    };

    vm.currentPage = 0;
    vm.resultsPerPage = 20;
    vm.pages = [];
    vm.paginationEllipses = {
        left: false,
        right: false,
    };

    vm.optionFilter = 1;
    vm.selectedOrder = 'date-descending';
    vm.promoCode = null;
    vm.promoCodeSet = false;
    vm.promoCodeChecking = false;
    vm.promoCodeFilter = true;
    vm.is_filtered = false;

    vm.production = 'any show';

    vm.loading = true;
    vm.updating = false;

    let productionNo = undefined;
    vm.event_view = false;

    const queryParams = new URLSearchParams(window.location.search);

    vm.updateDates = dateRange => {
        vm.date_filter = dateRange;
        vm.currentPage = 0;
    }

    vm.init = function () {

        productionNo = parseInt($attrs.prodSeasonNo, 10);

        vm.event_view = $attrs.eventView;

        let url = $location.search();

        window.addEventListener('popstate', event => {
            let state = event.state
            if(state && state.page) {
                vm.currentPage = +state.page - 1;
            } else {
                vm.currentPage = 0;
            }

            vm.findTickets();
        })

        if(url.page) {
            vm.currentPage = +url.page - 1;
        }

        if(url.production) {
            vm.selectedShow = url.production;
        }
        if(url.month) {
            vm.selectedMonth = url.month;
            let m = dates.moment().month(url.month);
            let start = m.clone().startOf('month');
            let end = m.clone().endOf('month');

            vm.date_filter = {
                start: start,
                end: end,
            }

            // these functions get set from calendar.js. this feels janky!
            let n = 0;
            let interval = setInterval(() => {
                n++;

                if(n > 10) {
                    clearInterval(interval);
                    return;
                }

                if(vm.updateCalendarSelectedRange) {
                    vm.updateCalendarSelectedRange(vm.date_filter.start, vm.date_filter.end);
                    vm.updateCalendarInputs(false, true);
                    clearInterval(interval);
                }
            }, 100);
        }

        plannerService.getPerformances().then(response => {
            let productions = uniqBy(response, 'prod_season_no');

            $scope.slider = {
                minValue: 0,
                maxValue: 150,
                options: {
                    floor: 0,
                    ceil: 150,
                    step: 10,
                    hideLimitLabels: true,
                    hidePointerLabels: true
                },
            }

            for (let index = 0; index < productions.length; index++) {
               const production = productions[index];
               if (maxTicketPrice < production.max_price) {
                maxTicketPrice = production.max_price;
               }
            }

            // --- promo code functionality ---

            $scope.applyPromoCode = function() {
                vm.promoCodeChecking = true;

                let check = plannerService.checkPromoCode(vm.promoCode);



                check.then(response => {
                    let data = {
                        mos: response.data.mos,
                        source_no: response.data.source_no,
                        promo_code: response.data.promo_code,
                        promo_text: response.data.text1,
                    };

                    cookies.set('mos', data, cookieSettings);
                    plannerService.addPromoCode(response.data.promo_code).then(response => {
                        // window.location.href = window.location.href;
                        vm.promoCodeChecking = false;
                        $window.location.reload();
                    });
                }).catch(e => {
                    console.warn(e)
                    console.warn('promo code invalid, or check failed!');
                    vm.promoCodeChecking = false;
                });

                vm.findTickets();

            }

            $scope.removePromoCode = function() {
                plannerService.removePromoCode().then(response => {
                    if (response.data.status === 'ok') {
                        cookies.set('mos', {}, cookieSettings);
                        $window.location.reload();
                    } else if (response.data.message) {
                        alert(response.data.message);
                    }
                });
            }

            try {
                const mos_data = cookies.get('mos');

                if (mos_data) {
                    vm.mos_data = JSON.parse(decodeURIComponent(decodeURIComponent(mos_data)));

                    if (vm.mos_data.promo_code) {
                        vm.promoCode = vm.mos_data.promo_code;
                        vm.promoCodeSet = true;
                    }
                }
            } catch (e) {
                console.warn(e)
            }

            // --- price range and selection functionality ---

            $scope.$on('slideEnded', function() {
                vm.selectedPriceRange = {
                    min: $scope.slider.minValue,
                    max: $scope.slider.maxValue,
                };

                vm.findTickets();
            });

            vm.showOptions = [
                {
                    prodSeasonNo: 0,
                    title: 'Any Show',
                    value: undefined
                }
            ];

            for (let index = 0; index < productions.length; index++) {
                vm.showOptions.push({
                    prodSeasonNo: productions[index].prod_season_no,
                    title: productions[index].title,
                    value: productions[index].title
                })
            }

            if (productionNo) {
                response = response.filter(production=>{
                    return production.prod_season_no === productionNo;
                });
            }

            allResults = response;
            allFilters = plannerService.generateFacets(response);

            // fuse = new FuseJS(allResults, plannerService.fuseOptions);

            const locationFacets = plannerService.locationFacets(allFilters, false);

            const reload = ( // probably should be called set up initial filters
                !isEmpty(url) &&
                // 'count' in url &&
                'production' in url //&&
                // 'pricerange' in url
            );

            // vm.selectedOrder = url.order || vm.selectedOrder;
            vm.selectedOrder = 'date-descending';

            if (reload) {
                vm.ticketCount = url.count;
                vm.selectedShow = url.production || 'Any Show';
                vm.optionFilter = (url.filter) ? parseInt(url.filter, 10) : null;
            }

            vm.findTickets();

            if (locationFacets) {
                let order = locationFacets.order;

                order = 'date-descending';

                // if (vm.optionFilter === 1) {
                //     vm.selectedOrder = 'best-seats';
                //     order = 'best-seats';
                // }

                // if (vm.optionFilter === 2) {
                //     vm.selectedOrder = 'lowest-price';
                //     order = 'lowest-price';
                // }

                applyFiltering(locationFacets.keyword, locationFacets.filters, order, false);
            } else {
                let results = allResults;
                if(vm.promoCodeSet && vm.promoCodeFilter) {
                    results = results.filter(production => {
                        return production.prices && production.prices.some(price => price.promo == 'Y');
                    });
                }

                updateView(results);
            }


            // Get a watcher going on keyword input, filters, and order
            $scope.$watch(() => [vm.keyword, vm.filters, vm.selectedOrder, vm.date_filter, vm.selectedShow, vm.promoCodeFilter], processChanges, true);

            // Get a watcher going on location search
            $scope.$watch(() => location.search, processLocation);

            vm.loading = false;

            vm.refreshSlider();
        }, e => {
            console.log(e);

            vm.errorLoading = true;
        }).catch(e => {
            console.log(e);

            vm.errorLoading = true;
        }).finally(function () {
            vm.loading = false;

            $(document).on('click', '.js-type-info', function (e) {
                $.magnificPopup.open({
                    items: {
                        src: e.currentTarget.getAttribute('href'),
                        type: 'inline',
                    }
                });
            });
        });
    }

    vm.clearFilters = function () {
        vm.filters.forEach(function (filter) {
            filter.keywords.forEach(function (keyword) {
                keyword.checked = false;
            });
        })
    }

    vm.refreshSlider = function() {
        $timeout(function() {
          $scope.$broadcast('rzSliderForceRender')
        })
      }

    vm.increment = function () {
        vm.ticketCount++;
    }

    vm.decrement = function () {
        if (vm.ticketCount === 0) {
            return;
        }

        vm.ticketCount--;
    }

    function filterEvents(filteredEvents)
    {
        if(vm.promoCodeSet && vm.promoCodeFilter) {
            filteredEvents = filteredEvents.filter(production => {
                return production.prices && production.prices.some(price => price.promo == 'Y');
            });
        }

        if (vm.selectedShow === 'Any Show') {
            vm.selectedShow = undefined;
        }

        if (vm.selectedShow) {
            filteredEvents = filter(filteredEvents, event => {
                return event.title === vm.selectedShow;
            });

            vm.production = find(vm.showOptions, option => {
                return option.title === vm.selectedShow;
            });
        } else {
            vm.production = 'Any Show';
        }

        if(vm.selectedMonth === 'any') {
            vm.selectedMonth = undefined;
        }



        if (vm.selectedMonth) {

            if(vm.selectedMonth === 'next 30 days') {
                let now = new Date();
                let dateStart = dates.moment(now.toString());
                let dateEnd = dates.moment(now.toString()).add(30, 'days');


                filteredEvents = filter(filteredEvents, event => {
                    // let month =    dates.moment(now.toString());
                    return event.start_date_moment.isAfter(dateStart) && event.end_date_moment.isBefore(dateEnd);

                });

            } else {
                filteredEvents = filter(filteredEvents, event => {
                    return event.date_formats.ticket__month.toLowerCase() === vm.selectedMonth.toLowerCase();
                });
            }
        }

        // currently broken
        if (vm.selectedPriceRange) {
            filteredEvents = filterByPriceRangeFlexible(vm.selectedPriceRange, filteredEvents);
        }



        // if (vm.optionFilter === 1) {
        //     filteredEvents = orderBy(filteredEvents, function (item) {
        //         return parseFloat(item.price)
        //     }, ['desc']);
        // }

        // if (vm.optionFilter === 2) {
        //     filteredEvents = orderBy(filteredEvents, function (event) {
        //         return parseFloat(event.price);
        //     }, ['asc']);
        // }

        return filteredEvents;
    }

    vm.findTickets = function() {
        let filteredEvents = allResults;

        if ($attrs.homePage === 'true') {
            let urlParams = 'count=' + vm.ticketCount + '&event=' + vm.selectedShow + '&pricerange=' + vm.selectedPriceRange;

            if (vm.optionFilter) {
                urlParams += '&filter=' + vm.optionFilter;
            }

            $window.location = $attrs.redirectUrl + '?' + urlParams;
        } else {
            filteredEvents = filterEvents(filteredEvents);

            // Figure out what we need to filter!
            const locationFacets = plannerService.locationFacets(vm.filters || allFilters, true);

            let order = locationFacets.order;

            if (vm.optionFilter === 1) {
                order = 'best-seats';
            }

            if (vm.optionFilter === 2) {
                order = 'lowest-price';
            }

            updateView(filteredEvents, [], locationFacets.keyword, order);

            vm.loading = false;
        }
    }

    function sortList(items, order) {
        if (order === 'best-seats') {
            return orderBy(items, ['price_float'], ['desc']);
        }

        if (order === 'lowest-price') {
            return orderBy(items, ['price_float'], ['asc']);
        }

        if (order === 'date-ascending') {
            return orderBy(items, ['start_date_value'], ['asc']);
        }

        if (order === 'date-descending') {
            return orderBy(items, ['start_date_value'], ['desc']);
        }

        if (order === 'high-availability') {
            return orderBy(items, ['avail_count'], ['desc']);
        }

        if (order === 'low-availability') {
            return orderBy(items, ['avail_count'], ['asc']);
        }

        return items;
    }

    function filterByPriceRangeFlexible(priceRange, performances) {

        let filtered = performances.filter(performance => {

            let inrange = false;

            // check to see if the max price of the performance is greater than 150.
            // if it is then set in range to true and we don't need to check for anything else.

            if(priceRange.max === 150){
                if (performance.max_price >= priceRange.max){
                    return true;
                }
            }

            // if the max range isn't greater than 150 then we need to filter by the ticket prices.
            if (!inrange) {

                for (let index = 0; index < performance.prices_collection.length; index++) {
                    const price = performance.prices_collection[index];
                    // check to see if an individual ticket price is withing range of the price filter min/max
                    if (price >= priceRange.min && price <= priceRange.max) {
                        return true;
                    }
                }
            }

            return inrange;

        });

        return filtered;
    }

    function processChanges(newVal, oldVal) {
        if (isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }
        vm.selectedMonth = undefined;
        vm.showClearDates = false;

        if (vm.date_filter.start !== undefined || vm.date_filter.end !== undefined){
            vm.showClearDates = true;
        }

        // ng-click="vm.clearDates()" ng-if="vm.showDates"
        applyFiltering(newVal[0], newVal[1], newVal[2], newVal[3], newVal[4], true);
    }

    function populatePages() {

        if (vm.results.length < 1){
            return [];
        }
        let pages = [];
        for(let i = 0, n = 0; i<vm.results.length; n++, i += vm.resultsPerPage) {
            pages.push({
                index: n,
                pageNo: n + 1,
                start: i,
                count: vm.resultsPerPage,
                visible: false,
                current: false,
            });
        }

        let surroundingPagesToShow = 3;

        for(
            let i = Math.max(0, vm.currentPage - surroundingPagesToShow + 1);
            i < Math.min(pages.length, vm.currentPage + surroundingPagesToShow);
            i++
        ) {
                let page = pages[i];
                page.visible = true;
        }

        vm.paginationEllipses.left = (vm.currentPage - surroundingPagesToShow + 1) > 0 ? true : false;
        vm.paginationEllipses.right = (vm.currentPage + surroundingPagesToShow) < pages.length ? true : false;

        let currentPage = pages[vm.currentPage];
        currentPage.current = true;

        return pages;
    }

    vm.goToPage = function(page) {
        var url = new URL(window.location);
        url.searchParams.set('page', page.index + 1);

        window.history.pushState({page: page.index + 1}, null, url.toString());

        vm.currentPage = page.index;
        vm.findTickets();


    }

    function processLocation(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        // Figure out what we need to filter!
        const locationFacets = plannerService.locationFacets(vm.filters, true);

        // Use that to apply our filtering
        applyFiltering(locationFacets.keyword, locationFacets.filters, locationFacets.order, false);
    }

    function applyFiltering(keyword, filters, order, dateRange, selectedShow, updateLocation) {
        // Keep track is updating to prevent watch firing

        vm.updating = true;


        // Grab our items to begin with
        let filteredItems = filterEvents(allResults);



        // Filter by keywords first if possible
        if (keyword && keyword.length) {
            filteredItems = fuse.search(keyword);
        }

        // Now, apply filters
        const result = plannerService.applyFilters({
            filters: filters,
            items: filteredItems
        });


        result.items = result.items.filter(perf => {
            if (!vm.date_filter.start || !vm.date_filter.end) {
                return true;
            }
            return vm.date_filter.start < perf.start_date_moment && vm.date_filter.end > perf.start_date_moment;
        });

        // Update location search on first load
        if (updateLocation) {
            plannerService.updateLocation(keyword, result.facets, order, selectedShow);
        }

        // Update view :3
        updateView(result.items, result.facets, keyword, order);
    }

    function updateView(items, facets, keyword, order) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Update keyword field if there's one in URL but not in field
        if (vm.keyword !== keyword) {
            vm.keyword = keyword;
        }

        // set to undefined to temporarily remove ordering

        order = 'date-ascending';
        if (!order) {
            order = 'date-ascending';
        }

        if (vm.order !== order) {
            vm.order = order;
        }

        // Grab count before grouped
        vm.totalCount = items.length;

        // Sort & assign results
        vm.results = sortList(items, order);
        vm.results = items;

        // Generate filters!
        vm.filters = plannerService.updateFilters({
            filters: vm.filters || allFilters,
            items: items,
            facets: facets || [],
            keyword: keyword
        });

        vm.is_filtered = vm.filters.reduce(function (carry, filter) {
            carry = filter.keywords.reduce(function (carry2, keyword) {
                return carry2 || keyword.checked;
            }, carry);
            return carry;
        }, false);

        vm.pages = populatePages();

        // Reset updating flag
        $timeout(function () {
            vm.updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$scope',
    '$timeout',
    '$attrs',
    '$window',
    '$location',
    'plannerService',
    controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/TicketFinderList.js